import React from "react";
import { Grid, Typography } from "@mui/material";
import Fade from "react-reveal/Fade";

const ExpWithPicRight = ({ smallTitle, title, content, imgUrl }) => {
  return (
    <Grid
      maxWidth="lg"
      container
      sx={{
        width: 1,
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        pb: 10,
      }}
    >
      <Grid
        item
        md={6}
        sm={12}
        sx={{
          width: { md: "600px", sm: 1 / 2 },
          height: { md: "600px", sm: "300px" },
          backgroundImage: `url("${imgUrl}")`,
          backgroundSize: { md: "cover", sm: "100% 100%" },
          display: { md: "none", sm: "inline-block" },
        }}
      ></Grid>
      <Grid
        item
        md={6}
        sm={12}
        sx={{ px: 4, py: { md: 20, sm: 10 }, fontSize: "30px" }}
      >
        <Fade delay={300}>
          <Typography sx={{ pb: 1, fontWeight: "bold", color: "#153a5b" }}>
            {smallTitle}
          </Typography>
          <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
            {title}
          </Typography>
        </Fade>
        <Fade delay={400}>
          <Typography
            className="normal"
            sx={{
              lineHeight: "200%",
              pt: 3,
              fontSize: "14px",
              color: "#5f6566",
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </Fade>
      </Grid>
      <Grid
        item
        md={6}
        sm={12}
        sx={{
          width: { md: "600px", sm: 1 / 2 },
          height: { md: "600px", sm: "300px" },
          backgroundImage: `url("${imgUrl}")`,
          backgroundSize: { md: "cover", sm: "100% 100%" },
          display: { md: "inline-block", sm: "none" },
        }}
      ></Grid>
    </Grid>
  );
};

export default ExpWithPicRight;
